module.exports = __webpack_public_path__ + "static/media/glacier.960508ce.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Header/images/backgrounds/glacier.png
 ** module id = 183
 ** module chunks = 0
 **/